<template>
    <van-overlay :show="imageShow" @click="imageShow = false" class="overlay">
        <div class="d-flex flex-v-c flex-l-c h-100">
            <div class="qrcode" @click.stop>
                <img :src="this.imageUrl" class="img" ref="image">
                {{tips}}
            </div>
        </div>
    </van-overlay>
</template>
<script>
import QRCode from 'qrcode';
import config from '@/config';
export default {
    name: 'QRCodeImage',
    props: {
        url: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            dafault: false
        }
    },
    watch: {
        url: function(value) {
            this.qrcodeUrl = '';
            this.imageUrl = '';
            this.createQrCodeImageUrl(config.WWW_URL + value);
        },
        value: function(val) {
            this.imageShow = val;
        },
        imageShow: function(val) {
            if (!val) {
                this.$emit('input', false);
            }
        }
    },
    data() {
        return {
            imageShow: false,
            qrcodeUrl: '',
            imageUrl: '',
            tips: '长按图片保存'
        };
    },
    mounted() {
        if (this.isMobile()) {
            return;
        }
        this.tips = '右键保存图片';
    },
    methods: {
        // 创建二维码
        createQrCodeImageUrl(text, width = 400) {
            let imageUrl = '';
            QRCode.toDataURL(text, { margin: 2, width: width, errorCorrectionLevel: 'H' }, (err, url) => {
                if (err) {
                    return '';
                }
                imageUrl = url;
            });
            const { canvas, context } = this.createCanvas(width, width);
            const qrcodeImage = new Image();
            const logoImage = new Image();
            // 二维码图
            qrcodeImage.src = imageUrl;
            logoImage.src = require('../assets/img/icon.png'); // 你自己本地的图片或者在线图片
            let loadFlag = true;
            qrcodeImage.onload = () => {
                this.qrcodeUrl = this.drawImages(canvas, context, { image: qrcodeImage, startX: 0, startY: 0, width: width, height: width },
                    { image: logoImage, startX: 150, startY: 150, width: 100, height: 100 }, loadFlag);
                if (!loadFlag) {
                    this.overlayBackgroundPicture();
                }
                loadFlag = false;
            };
            logoImage.onload = () => {
                this.qrcodeUrl = this.drawImages(canvas, context, { image: qrcodeImage, startX: 0, startY: 0, width: width, height: width },
                    { image: logoImage, startX: 150, startY: 150, width: 100, height: 100 }, loadFlag);
                if (!loadFlag) {
                    this.overlayBackgroundPicture();
                }
                loadFlag = false;
            };
        },
        overlayBackgroundPicture() {
            const { canvas, context } = this.createCanvas(750, 1350);
            const qrcodeImage = new Image();
            const backgroundImage = new Image();
            // 二维码图
            qrcodeImage.src = this.qrcodeUrl;
            backgroundImage.src = require('../assets/img/qr-background.png'); // 你自己本地的图片或者在线图片
            let loadFlag = true;
            backgroundImage.onload = () => {
                this.imageUrl = this.drawImages(canvas, context, { image: backgroundImage, startX: 0, startY: 0, width: 750, height: 1350 },
                    { image: qrcodeImage, startX: 285, startY: 1016, width: 180, height: 180 }, loadFlag);
                loadFlag = false;
            };
            qrcodeImage.onload = () => {
                this.imageUrl = this.drawImages(canvas, context, { image: backgroundImage, startX: 0, startY: 0, width: 750, height: 1350 },
                    { image: qrcodeImage, startX: 285, startY: 1016, width: 180, height: 180 }, loadFlag);
                loadFlag = false;
            };
        },
        // 创建canvas
        createCanvas(width, height, fillColor = '#FFF') {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const context = canvas.getContext('2d');
            context.rect(0, 0, width, height);
            context.fillStyle = fillColor;
            context.fill();
            return { canvas, context };
        },
        // 在两张图片加载完后绘图
        drawImages(canvas, context, fitst, second, bool) {
            if (bool) {
                return '';
            }
            context.drawImage(fitst.image, fitst.startX, fitst.startY, fitst.width, fitst.height);
            context.drawImage(second.image, second.startX, second.startY, second.width, second.height);
            return canvas.toDataURL('image/png'); // "image/png" 这里注意一下
        },
        // 是否是移动端
        isMobile() {
            return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        }
    }
};
</script>
<style lang="scss" scoped>
.overlay {
    height: 100%;
}
.qrcode {
    width: 80%;
    max-width: 450px;
    max-height: 100%;
    background: #fff;
    text-align: center;
    padding-bottom: 10px;
    font-weight: 600;
    .img {
        width: 100%;
    }
}
</style>
